import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminCampaignCategoryModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminCampaignCategoryModule;